import { z } from 'zod'

const allUpperCase = /^[A-Z0-9]{7}$/
const caseInsensitive = /^[A-Z0-9]{7}$/i

export const isValidMachineGroupId = (
  id: unknown,
  options?: { caseInsensitive: boolean }
): id is string => {
  if (options?.caseInsensitive) {
    return new RegExp(caseInsensitive).test(`${id}`)
  }

  return new RegExp(allUpperCase).test(`${id}`)
}

export const MachineGroupIdSchema = z.string().regex(allUpperCase)
export const MachineGroupIdSchemaCaseInsensitive = z
  .string()
  .regex(caseInsensitive)
  .transform((id) => id.toUpperCase())
